import ContentLoader from 'react-content-loader';

const JobMetadataLoader = () => (
  <ContentLoader
    data-test-id="job-metadata-loader"
    backgroundColor="rgba(0,96,250, 0.1)"
    foregroundColor="rgba(204,116,245, 0.3)"
    viewBox="0 0 380 48"
  >
    <rect x="0" y="1" rx="3" ry="3" width="15%" height="6" />
    <rect x="17%" y="1" rx="3" ry="3" width="30%" height="6" />
    <rect x="53%" y="1" rx="3" ry="3" width="15%" height="6" />
    <rect x="70%" y="1" rx="3" ry="3" width="30%" height="6" />

    <rect x="0" y="11" rx="3" ry="3" width="15%" height="6" />
    <rect x="17%" y="11" rx="3" ry="3" width="30%" height="6" />
    <rect x="53%" y="11" rx="3" ry="3" width="15%" height="6" />
    <rect x="70%" y="11" rx="3" ry="3" width="30%" height="6" />

    <rect x="0" y="21" rx="3" ry="3" width="15%" height="6" />
    <rect x="17%" y="21" rx="3" ry="3" width="30%" height="6" />
    <rect x="53%" y="21" rx="3" ry="3" width="15%" height="6" />
    <rect x="70%" y="21" rx="3" ry="3" width="30%" height="6" />

    <rect x="0" y="31" rx="3" ry="3" width="15%" height="6" />
    <rect x="17%" y="31" rx="3" ry="3" width="30%" height="6" />
    <rect x="53%" y="31" rx="3" ry="3" width="15%" height="6" />
    <rect x="70%" y="31" rx="3" ry="3" width="30%" height="6" />

    <rect x="0" y="41" rx="3" ry="3" width="15%" height="6" />
    <rect x="17%" y="41" rx="3" ry="3" width="30%" height="6" />
    <rect x="53%" y="41" rx="3" ry="3" width="15%" height="6" />
    <rect x="70%" y="41" rx="3" ry="3" width="30%" height="6" />
  </ContentLoader>
);

export default JobMetadataLoader;
